export default "__VITE_ASSET__BIIeWCJz__"